import { useState, useEffect, useRef, useCallback } from 'react';

import { supportedCurrencies, defaultCurrencyByCountry } from '../utils/CurrencyUtils';

/**
 * Claim flow currency: country default, then tag/template default, unless the user
 * (or team picker) explicitly chose a currency — tag snapshots must not overwrite that.
 */
export function useClaimScreenCurrency(client, tag) {
  const [currency, setCurrency] = useState(null);
  const userChoseCurrencyRef = useRef(false);

  const applyUserCurrencyChoice = useCallback((next) => {
    userChoseCurrencyRef.current = true;
    setCurrency(next);
  }, []);

  useEffect(() => {
    if (client?.country && !currency) {
      setCurrency(defaultCurrencyByCountry[client.country] || null);
    }
  }, [client, currency]);

  useEffect(() => {
    if (userChoseCurrencyRef.current) return;
    if (tag?.paymentDetails?.currency && supportedCurrencies[tag.paymentDetails.currency]) {
      setCurrency(tag.paymentDetails.currency);
    }
  }, [tag]);

  return [currency, applyUserCurrencyChoice, setCurrency];
}
